import { useEffect } from 'react';

import { getExperimentAssignment } from '@eventbrite/legacy-infra.statsig';

import { onStatsigReady } from '../../../../common/statsig';
import type { ListingPageProps } from '@/pages/listingPageTypes';

type UseExperimentAssignmentMismatchEffectArgs = {
  experiments: ListingPageProps['experiments'];
};

export function useExperimentAssignmentMismatchEffect({ experiments }: UseExperimentAssignmentMismatchEffectArgs) {
  useEffect(() => {
    onStatsigReady(() => {
      if (!experiments) {
        return;
      }
      Object.entries(experiments).forEach(([experimentName, experimentData]) => {
        const clientSideExperimentAssignment = getExperimentAssignment(experimentName);
        if (clientSideExperimentAssignment?.getGroupName() !== experimentData.groupName) {
          console.error('[Statsig Error] Experiment Assignment Mismatch!', {
            experimentName,
            serverSideGroupName: experimentData.groupName,
            clientSideGroupName: clientSideExperimentAssignment?.getGroupName(),
          });
        }
      });
    });
  }, [experiments]);
}
